import { DragSource } from 'react-dnd';
import { ItemTypes } from 'constants/itemTypes';

const sectionSource = {
  beginDrag(
    { position, parent_id, type, content, ...props },
    monitor,
    component,
  ) {
    props.toggleDragging();
    return { position, parent_id, type, content };
  },
  // eslint-disable-next-line
  endDrag(props, monitor, component) {
    props.toggleDragging();
    const results = monitor.getDropResult();
    const didDrop = monitor.didDrop();
    if (!didDrop) {
      return false;
    }
    if (results.parentId) {
      props.assignParent(results.parentId);
    } else if (!results.detached) {
      props.order(results.newPosition);
    } else if (results.detached) {
      props.detachParent(results.newPosition);
    }
  },
};

const collect = (connector, monitor) => ({
  connectDragSource: connector.dragSource(),
  connectDragPreview: connector.dragPreview(),
  isDragging: monitor.isDragging(),
});

export default DragSource(ItemTypes.ELEMENT, sectionSource, collect);
